import { spring } from 'motion';

export const animateOptions = { duration: 0.35, bounce: 0, type: spring };

/**
 * https://easings.net/#easeOutBack
 * @param x
 * @returns
 */
export function easeOutBack(x: number): number {
  const c1 = 1.70158;
  const c3 = c1 + 1;

  return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2);
}

export function fix1px(value: number) {
  return value < 0.5 ? 0 : value;
}

/**
 * 线性函数
 * @param t
 * @returns
 */
export function linear(t: number) {
  return t;
}

/**
 * 类似树木生长的动画
 * @param t
 * @param diff
 * @returns
 */
export function grow(t: number, diff: number) {
  let x: number, y: number;
  const reverseDiff = 1 - diff;
  if (t <= diff) {
    x = t;
  } else {
    x =
      t === 1 ? 1 : diff + easeOutBack((t - diff) / reverseDiff) * reverseDiff;
  }
  if (t <= reverseDiff) {
    y = easeOutBack(t / reverseDiff);
  } else {
    y = 1;
  }

  return [x, y];
}
